import { FileOutlined } from '@ant-design/icons'
import { Typography } from 'antd'
import { relativeTimeString } from 'enrollment-platform/utils/relative-time-string'
import React from 'react'
import { CensusUploadJobDto } from '../api/dto/census-upload-job.dto'
import CensusQueueActionsCell from './CensusQueueActionsCell'
import CensusQueueStatusCell from './CensusQueueStatusCell'

const { Text } = Typography

// One Drafts column, drawn for an unfinished upload pinned above the files
function DraftsQueueCell({
  field,
  job,
  clientNameLookup,
  onChanged,
  canDismiss,
}: {
  field?: string
  job: CensusUploadJobDto
  clientNameLookup: Record<string, string>
  onChanged: () => void
  canDismiss: boolean
}) {
  // Unfinished uploads are greyed out: nothing to review yet
  const isRunning = job.status !== 'FAILED'
  const textType = isRunning ? 'secondary' : undefined
  switch (field) {
    case 'createdAt':
      return (
        <Text className="textSm" type={textType}>
          {relativeTimeString(job.createdAt, 1)}
        </Text>
      )
    case 'clientPublicKey':
      return (
        <Text className="textEmphasis" type={textType}>
          {clientNameLookup[job.clientPublicKey] ?? 'loading...'}
        </Text>
      )
    case 'rowTypeCount':
      return <CensusQueueStatusCell job={job} />
    case 'uploadByEmail':
      return (
        <Text className="textSm" type={textType}>
          {job.uploadedBy ?? '-'}
        </Text>
      )
    case 'fileName':
      return (
        <>
          <FileOutlined style={{ fontSize: '14px', marginRight: '8px' }} />
          <Text className="textSm textGray">{job.fileName}</Text>
        </>
      )
    case 'review':
      if (isRunning) {
        return (
          <Text className="textSm" type="secondary">
            Processing...
          </Text>
        )
      }
      return canDismiss ? (
        <CensusQueueActionsCell job={job} onChanged={onChanged} />
      ) : null
    default:
      return null
  }
}

export default DraftsQueueCell
